/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */


(function ($) {
    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function () {
                // JavaScript to be fired on all pages
                $('.off-canvas-btn').on('click', function () {
                    $('.site-wrapper-inner').toggleClass('off-to-right');
                });

            },

            finalize: function () {

                $('.projects-filter').navStrip();

                $('.dropdown-menu .menu-item').on('click', function (e) {
                    $(this).addClass('active');
                    e.stopPropagation();
                });

                $(window).resize(function () {

                    var w = $(window).width();
                    var h = $('.video-bg').height();
                    var newW = (h * 1.77777778);
                    var newH = (w / 1.77777778);


                    if ((w > 1280) && (newH > h )) {
                        $('.video-full').css({'width': w, 'height': newH});
                    }
                    if ((h > 720) && (newW > w )) {
                        $('.video-full').css({'height': h, 'width': newW});
                    }

                }).resize();

                window.Cubes.load();
            }
        },
        // Home page
        'home': {
            init: function () {
                // JavaScript to be fired on the home page
            },
            finalize: function () {

                var $grid = $('.grid').imagesLoaded(function () {
                    setTimeout(function () {
                        $grid.isotope({
                            itemSelector: '.grid-item',
                            percentPosition: true,
                            masonry: {
                                columnWidth: '.grid-sizer'
                            }
                        });
                    }, 1200);
                });
            }
        },
        'firm': {
            finalize: function () {

            }
        },
        'architecture': {
            finalize: function () {

                $.extend($.lazyLoadXT, {
                    forceEvent: 'layoutIso',
                    forceLoad : true
                });

                var $grid = $('.grid').imagesLoaded(function () {

                    $grid.isotope({
                        layoutMode: 'fitRows',
                        itemSelector: '.grid-item',
                        percentPosition: true,
                    });
                });

                $('.projects-filter li > a').on('click', function (e) {

                    $('.projects-filter .active').removeClass('active');
                    $(this).parent().addClass('active');
                    $grid.isotope({filter: $(this).attr('filter')});

                });
            }
        },
        'singular': {
            finalize: function () {
            }
        },
        'projects': {
            finalize: function () {

                var swiper = new Swiper('.swiper-container', {
                    pagination: '.swiper-pagination',
                    paginationClickable: true,
                    nextButton: '.swiper-button-next',
                    prevButton: '.swiper-button-prev',
                    spaceBetween: 30,
                    // Disable preloading of all images
                    preloadImages: false,
                    // Enable lazy loading
                    lazyLoading: true
                });
                /*
                 var swiper_similar = new Swiper('.swiper-similar', {
                 //pagination: '.swiper-pagination',
                 //paginationClickable: true,
                 nextButton: '.swiper-button-next',
                 prevButton: '.swiper-button-prev',
                 spaceBetween: 0,
                 slidesPerView: 3,
                 // Disable preloading of all images
                 preloadImages: false,
                 // Enable lazy loading
                 lazyLoading: true,
                 breakpoints: {
                 992: {
                 slidesPerView: 2,
                 spaceBetween: 0
                 },
                 500: {
                 slidesPerView: 1,
                 spaceBetween: 0
                 }
                 }
                 });
                 */

                var $grid = $('.grid').imagesLoaded(function () {

                    $grid.isotope({
                        layoutMode: 'fitRows',
                        itemSelector: '.grid-item',
                        percentPosition: true,
                    });
                });
            }
        },
        'services': {
            init: function () {

            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery);